import { useSetAtom } from "jotai";
import { busiMessageList, getUnreadNum } from "../API";
import { NoticeCountAtom, SystemMsgCountAtom } from "../Stores/CommonStore";
import { useLocation } from "react-router-dom";

// 更新系统消息个数
export function useUpdateNoticeCount() {
    const location = useLocation();
    const updateSystemCount = useSetAtom(SystemMsgCountAtom);
    const updateNoticeCount = useSetAtom(NoticeCountAtom);

    return () => {
        if (location.pathname.startsWith("/login")) return;
        const promise1: Promise<number> = busiMessageList(true)
            .then(data => {
                updateSystemCount(data.length);
                return data.length;
            })
            .catch(() => 0);

        const promise2: Promise<number> = getUnreadNum()
            .then(count => {
                updateNoticeCount(count);
                return count;
            })
            .catch(() => 0);

        Promise.all([promise1, promise2]).then(([count1, count2]) => {
            if (!window.ReactNativeWebView) return;
            window.ReactNativeWebView.call("setBadgeNum", count1 + count2);
        });
    };
}
